module.exports = __webpack_public_path__ + "static/x4a-4ada8ed3f1a39be21d7c0764b6d00b68.png";